import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { mapState } from "vuex";
import { message } from "ant-design-vue";
export default {
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String,
      default: "未命名组件"
    },
    index: {
      type: Number,
      default: 0
    },
    components: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      mouse_hover_id: 0,
      // 鼠标经过的ID,
      componentTitle: this.title,
      // 组件标题
      isEdit: false // componentTitle 是否可以编辑,
    };
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapState({
    copyable: function copyable(state) {
      var _this = this;
      /* let component = state.design.components[this.index]; */
      var component = state.design.components.filter(function (item) {
        return item.id === _this.id;
      })[0];
      var componentTemplate = state.design.componentTemplates.filter(function (item) {
        return item.name == component.name;
      });

      /* if ( this.$store.getters['design/curComponentNum'][component.name] >= componentTemplate[0].maxNum  ) { */
      if (this.$store.getters["design/curComponentNum"][component.name] >= component.maxNum) {
        return false;
      }
      return true;
    },
    /* components: (state) => state.design.components, */
    design_selected_id: function design_selected_id(state) {
      return state.design.selected_id;
    },
    // 装修页选中的组件ID
    show_component_form: function show_component_form(state) {
      return state.design.show_component_form;
    },
    in_drag: function in_drag(state) {
      return state.design.preview_in_drag;
    } // 是否在拖拽状态中
  }))
};